import { useCallback, useEffect, useState } from "react";
import { getDbtDocsShareDetailsById } from "../api/index";
import { DbtDocsState, setManifest } from "./DbtDocsReducer";
import {
  useDbtDocsCollaborationDispatch,
  useDbtDocsCollaborationSelector,
} from "./DbtDocsCollaborationProvider";
import { DbtDocsShareDetails } from "./types";

const useDbtDocsCollaboration = () => {
  const shareId = useDbtDocsCollaborationSelector(
    state => state.shareId
  ) as DbtDocsState["shareId"];
  const [shareDetails, setShareDetails] = useState<DbtDocsShareDetails | null>(null);
  const [loading, setLoading] = useState(false);
  const dispatch = useDbtDocsCollaborationDispatch();

  useEffect(() => {
    if (!shareDetails?.manifest_presigned_url) {
      return;
    }

    fetch(shareDetails.manifest_presigned_url)
      .then(response => response.json())
      .then(response => {
        dispatch(setManifest(response));
      })
      .catch(error =>
        console.error("error loading manifest", error, shareDetails.manifest_presigned_url)
      );
  }, [dispatch, shareDetails?.manifest_presigned_url]);

  const loadDetails = useCallback(async () => {
    if (!shareId) {
      return;
    }
    setLoading(true);
    const response = await getDbtDocsShareDetailsById(shareId);
    if (response) {
      setShareDetails(response);
      // Hack to close the sidebar when dbt docs is shown
      const leftArrowBtn = document.getElementById("collapse-sidebar");
      leftArrowBtn?.click();
    }
    setLoading(false);
  }, [shareId]);

  useEffect(() => {
    if (!shareId || shareDetails || loading) {
      return;
    }
    loadDetails();
  }, [shareId, shareDetails, loadDetails, loading]);

  return { shareDetails, loading };
};

export default useDbtDocsCollaboration;
